"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var S = _interopRequireWildcard(require("./styles/Checkbox.style"));
var _excluded = ["className", "disabled", "onChange", "checked", "defaultChecked", "required", "name", "asChild"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.439 6.035a1.445 1.445 0 0 0-2.02 0 1.39 1.39 0 0 0 0 1.988l5.613 5.524a1.59 1.59 0 0 0 2.222 0L19.582 2.4a1.39 1.39 0 0 0 0-1.988 1.445 1.445 0 0 0-2.02 0L7.141 10.664 2.44 6.035z"
  }));
};
CheckIcon.defaultProps = {
  fill: "currentColor",
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  xmlns: "http://www.w3.org/2000/svg"
};
var Checkbox = function Checkbox(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    required = _ref.required,
    name = _ref.name,
    asChild = _ref.asChild,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(S.Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(S.CheckboxRoot, _extends({
    onCheckedChange: onChange,
    disabled: disabled,
    defaultChecked: defaultChecked,
    checked: checked,
    name: name,
    hidden: true
  }, props), /*#__PURE__*/_react["default"].createElement(S.CheckboxIndicator, null, /*#__PURE__*/_react["default"].createElement(CheckIcon, null))));
};
var _default = exports["default"] = Checkbox;